<template>
    <div>
        <Row type="flex" justify="end" style="margin-bottom: 40px;">
            <i-col>
                <InputNumber @input="carregarDados()" :active-change="false" :min="1" v-model="period" style="margin-left:7px;"></InputNumber>
                <i-switch @on-change="carregarDados()" false-value="mensal" size="large" style="margin: 7px 0 7px 7px;"
                            true-value="semanal" v-model="format">
                    <span slot="open">SEM</span>
                    <span slot="close">MEN</span>
                </i-switch>
            </i-col>
        </Row>
        <bar-chart
            v-if="mostrar_grafico_line"
            :options="dados_grafico_line"
            @click="getDadosDetalhados"
        />
        <Row type="flex" justify="center" class="pb-10">
            <i-col span="12">
                <bar-chart
                    v-if="mostrar_grafico_pie"
                    :options="dados_grafico_pie"
                    @hover="hover"
                    @out="out"
                    @click="getDetalhes"
                />
            </i-col>
            <i-col span="12">
                <ButtonGroup horizontal>
                    <i-button type="text" class="bg-red-lighter m-1 border-2 
                                                hover:border-red focus:border-red 
                                                focus:border-red h-full"
                        :class="actives_detractors[0].all || actives_detractors[1].value" @click="getActives(1,'detractors',0)">
                        <label class="text-red-dark text-lg">0</label>
                        <br>
                        <feather-icon svgClasses="w-6 text-red-dark" class="pl-1 pr-1" icon="FrownIcon">
                        </feather-icon>
                        <br>
                        {{getScore(0).value || '-'}}
                    </i-button>
                    <i-button type="text" class="bg-red-lighter m-1 border-2 
                                                hover:border-red focus:border-red 
                                                focus:border-red h-full"
                        :class="actives_detractors[0].all || actives_detractors[2].value" @click="getActives(2,'detractors',1)">
                        <label class="text-red-dark text-lg">1</label>
                        <br>
                        <feather-icon svgClasses="w-6 text-red-dark" class="pl-1 pr-1" icon="FrownIcon">
                        </feather-icon>
                        <br>
                        {{getScore(1).value || '-'}}
                    </i-button>
                    <i-button type="text" class="bg-red-lighter m-1 border-2 
                                                hover:border-red focus:border-red 
                                                focus:border-red h-full"
                        :class="actives_detractors[0].all || actives_detractors[3].value" @click="getActives(3,'detractors',2)">
                        <label class="text-red-dark text-lg">2</label>
                        <br>
                        <feather-icon svgClasses="w-6 text-red-dark" class="pl-1 pr-1" icon="FrownIcon">
                        </feather-icon>
                        <br>
                        {{getScore(2).value || '-'}}
                    </i-button>
                    <i-button type="text" class="bg-red-lighter m-1 border-2 
                                                hover:border-red focus:border-red 
                                                focus:border-red h-full"
                        :class="actives_detractors[0].all || actives_detractors[4].value" @click="getActives(4,'detractors',3)">
                        <label class="text-red-dark text-lg">3</label>
                        <br>
                        <feather-icon svgClasses="w-6 text-red-dark" class="pl-1 pr-1" icon="FrownIcon">
                        </feather-icon>
                        <br>
                        {{getScore(3).value || '-'}}
                    </i-button>
                    <i-button type="text" class="bg-red-lighter m-1 border-2 
                                                hover:border-red focus:border-red 
                                                focus:border-red h-full"
                        :class="actives_detractors[0].all || actives_detractors[5].value" @click="getActives(5,'detractors',4)">
                        <label class="text-red-dark text-lg">4</label>
                        <br>
                        <feather-icon svgClasses="w-6 text-red-dark" class="pl-1 pr-1" icon="FrownIcon">
                        </feather-icon>
                        <br>
                        {{getScore(4).value || '-'}}
                    </i-button>
                    <i-button type="text" class="bg-red-lighter m-1 border-2 
                                                hover:border-red focus:border-red 
                                                focus:border-red h-full"
                        :class="actives_detractors[0].all || actives_detractors[6].value" @click="getActives(6,'detractors',5)">
                        <label class="text-red-dark text-lg">5</label>
                        <br>
                        <feather-icon svgClasses="w-6 text-red-dark" class="pl-1 pr-1" icon="FrownIcon">
                        </feather-icon>
                        <br>
                        {{getScore(5).value || '-'}}
                    </i-button>
                    <i-button type="text" class="bg-red-lighter m-1 border-2 
                                                hover:border-red focus:border-red 
                                                focus:border-red h-full"
                        :class="actives_detractors[0].all || actives_detractors[7].value" @click="getActives(7,'detractors',6)">
                        <label class="text-red-dark text-lg">6</label>
                        <br>
                        <feather-icon svgClasses="w-6 text-red-dark" class="pl-1 pr-1" icon="FrownIcon">
                        </feather-icon>
                        <br>
                        {{getScore(6).value || '-'}}
                    </i-button>
                    <i-button type="text" class="bg-yellow-lighter m-1 border-2 
                                            hover:border-yellow-dark 
                                            focus:border-yellow-dark h-full"
                        :class="actives_passives[0].all || actives_passives[1].value" @click="getActives(1,'passives',7)">
                        <label class="text-yellow-dark text-lg">7</label>
                        <br>
                        <feather-icon svgClasses="w-6 text-yellow-dark" class="pl-1 pr-1" icon="MehIcon">
                        </feather-icon>
                        <br>
                        {{getScore(7).value || '-'}}
                    </i-button>
                    <i-button type="text" class="bg-yellow-lighter m-1 border-2 
                                            hover:border-yellow-dark 
                                            focus:border-yellow-dark h-full"
                        :class="actives_passives[0].all || actives_passives[2].value" @click="getActives(2,'passives',8)">
                        <label class="text-yellow-dark text-lg">8</label>
                        <br>
                        <feather-icon svgClasses="w-6 text-yellow-dark" class="pl-1 pr-1" icon="MehIcon">
                        </feather-icon>
                        <br>
                        {{getScore(8).value || '-'}}
                    </i-button>
                    <i-button type="text" class="bg-green-lighter m-1 border-2 
                                                hover:border-green 
                                                focus:border-green h-full"
                        :class="actives_promoters[0].all || actives_promoters[1].value" @click="getActives(1,'promoters',9)">
                        <label class="text-green-dark text-lg">9</label>
                        <br>
                        <feather-icon svgClasses="w-6 text-green-dark" class="pl-1 pr-1" icon="SmileIcon">
                        </feather-icon>
                        <br>
                        {{getScore(9).value || '-'}}
                    </i-button>
                    <i-button type="text" class="bg-green-lighter m-1 border-2 
                                                hover:border-green 
                                                focus:border-green h-full"
                        :class="actives_promoters[0].all || actives_promoters[2].value" @click="getActives(2,'promoters',10)">
                        <label class="text-green-dark text-lg">10</label>
                        <br>
                        <feather-icon svgClasses="w-6 text-green-dark" class="pl-1 pr-1" icon="SmileIcon">
                        </feather-icon>
                        <br>
                        {{getScore(10).value || '-'}}
                    </i-button>
                </ButtonGroup>
                <Row type="flex" justify="center">
                    <i-col class="pt-4">
                        <h2>NPS = {{(getScore('promoters').percent - getScore('detractors').percent).toFixed(2).replace('.',',')}}% (<label class="text-green">%Promoters</label> - <label class="text-red">%Detractors</label>)</h2>
                    </i-col>
                </Row>
                <Row type="flex" justify="center" class="pt-10">
                    <i-col span="8" class="mr-16">
                        <h2>
                            <label class="rounded-full py-2 px-4 bg-red-lighter">Detractors</label>
                        </h2>
                    </i-col>
                    <i-col span="4" class="mr-16">
                        <h2>
                            <label class="rounded-full py-2 px-4 bg-red-dark text-white">{{getScore('detractors').value}}</label>
                        </h2>
                    </i-col>
                    <i-col span="4">
                        <h2>
                            <label class="rounded-full py-2 px-4 bg-red-lighter mr-4">{{(getScore('detractors').percent).replace('.',',')}}%</label>
                        </h2>
                    </i-col>
                </Row>
                <Row type="flex" justify="center" class="pt-10">
                    <i-col span="8" class="mr-16">
                        <h2>
                            <label class="rounded-full py-2 px-8 bg-yellow-lighter mr-16">Passives</label>
                        </h2>
                    </i-col>
                    <i-col span="4" class="mr-16">
                        <h2>
                            <label class="rounded-full py-2 px-4 bg-yellow-dark mr-16 text-white">{{getScore('passives').value}}</label>
                        </h2>
                    </i-col>
                    <i-col span="4">
                        <h2>
                            <label class="rounded-full py-2 px-4 bg-yellow-lighter mr-4">{{(getScore('passives').percent).replace('.',',')}}%</label>
                        </h2>
                    </i-col>
                </Row>
                <Row type="flex" justify="center" class="pt-10">
                    <i-col span="8" class="mr-16">
                        <h2>
                            <label class="rounded-full py-2 px-4 bg-green-lighter mr-16">Promoters</label>
                        </h2>
                    </i-col>
                    <i-col span="4" class="mr-16">
                        <h2>
                            <label class="rounded-full py-2 px-4 bg-green-dark mr-16 text-white">{{getScore('promoters').value}}</label>
                        </h2>
                    </i-col>
                    <i-col span="4">
                        <h2>
                            <label class="rounded-full py-2 px-4 bg-green-lighter mr-4">{{(getScore('promoters').percent).replace('.',',')}}%</label>
                        </h2>
                    </i-col>
                </Row>
            </i-col>
        </Row>
        <Spin size="large" fix v-if="carregar"></Spin>
        <i-table v-if="mostrar_tabela" ref="table" :columns="columns" :data="dados_tabela" :loading="carregar_tabela"></i-table>
    </div>
</template>

<script>
const {moment} = require("../../../helpers/utils.js")
export default {
    components: {
        BarChart: () => import("../../../components/charts/BarChart.vue"),
    },
    props: {
        type:String,
        download: Boolean,
        refresh: Boolean,
        close: Boolean
    },
    data:() => ({
        period: 6,
        format: 'semanal',
        dados:[],
        dados_detalhados:[],
        dados_grafico_line: {},
        dados_grafico_pie: {},
        nps: [],
        dados_tabela: [],
        columns: [
                    {
                        title: 'Empresa',
                        key: 'nome_empresa',
                        sortable:true,
                        render: (h, params) => {
                            const id = params.row.id_empresa+' - '
                            let nome = params.row.nome_empresa
                            nome = nome?id+nome:id
                            return h("span",
                                [
                                    nome
                                ]
                            )
                        }
                    },
                    {
                        title: 'Pessoa',
                        key: 'nome_pessoa',
                        sortable:true,
                        render: (h, params) => {
                            const id = params.row.id_pessoa+' - '
                            let nome = params.row.nome_pessoa
                            nome = nome?id+nome:id
                            return h("span",
                                    nome
                            )
                        }
                    },
                    {
                        title: 'Nota',
                        key: 'nota',
                        sortable:true,
                        align:'center'
                    },
                    {
                        title: 'Média',
                        align:'center',
                        maxWidth:150
                    },
        ],
        mostrar_grafico_line:true,
        mostrar_grafico_pie:true,
        carregar: false,
        mostrar_tabela:false,
        carregar_tabela: false,
        actives_detractors:[],
        actives_passives:[],
        actives_promoters:[]
    }),
    computed:{
        getTotal(){
            return this.dados_detalhados.map(item => ({
                value: item.length,
            })).reduce( ( prevVal, elem ) => prevVal + elem.value, 0 )
        },
    },
    methods: {
        async carregarDados() {
            this.carregar = true
            const {data} = await this.$axios.get('nps',{params: {format:this.format, period:this.period,type:this.type}})
            this.dados = data.reverse()
            this.dados = this.dados.map(item => {
                item = item.filter(value => {
                    return value.nota != null
                })
                return item
            })
            this.dados_detalhados = this.dados
            this.mostrarDados()
            this.carregar = false
        },
        mostrarDados() {
            let legenda = this.caregarLegenda(this.dados.length)
            let quantidades = this.dados.map(item => ({
                value: item.length,
                itemStyle: {
                    barBorderColor: '#FF1744',
                }
            }))
            let totais = quantidades.map((item,key) => {
                item['quantidade'] = quantidades.filter((value,index) => {
                    return index <= key
                }).reduce( ( prevVal, elem ) => prevVal + elem.value, 0 )
                return item.quantidade
            })
            let nps = []
            totais.forEach((element,index) => {
                nps.push(
                    {
                        value:(this.getScore('promoters',this.dados.filter((item,key) => {
                            return key <= index
                        }),element).percent - this.getScore('detractors',this.dados.filter((item,key) => {
                            return key <= index
                        }),element).percent).toFixed(2),
                        dados:this.dados.filter((item,key) => {
                            return key <= index
                        })
                    } 
                )
            })
            legenda = this.filter(legenda)
            quantidades = this.filter(quantidades)
            totais = this.filter(totais)
            this.nps = this.filter(nps)
            this.dados_grafico_line = {
                    tooltip: {
                        type:'shadow',
                        formatter:(params)=>{
                            return `
                                <span>${params.seriesName}</span><br>
                                <span>${params.marker} ${params.name}: ${(params.data.value+'').replace('.',',')}</span><br>
                            `
                        }
                    },
                    legend: {},
                    xAxis: {
                        data: legenda,
                        silent: false,
                        axisLine: {onZero: true},
                        splitArea: {show: false},
                        splitLine: {show: false}
                    },
                    yAxis: {},
                    grid: {
                        left: 50,
                        right: 50
                    },
                    label: {
                        position: 'inside',
                        show: true,
                        formatter: (params) => params.value? (params.value+'').replace('.',',') : '',
                    },
                    series: [
                        {
                            name: 'Alcance',
                            type: 'bar',
                            color: '#0080c0',
                            stack:'total',
                            data: quantidades,
                        },
                        {
                            name: 'NPS',
                            type: 'line',
                            color: '#263238',
                            stack:'total',
                            data: this.nps,
                        }
                    ]
            }
            this.mostrarDetalhes([
                this.getScore('detractors').value,
                this.getScore('passives').value,
                this.getScore('promoters').value,
            ])
        },
        filter(dados){
            return dados.reverse().filter((item,key) => {
                return key <= this.period
            }).reverse()
        },
        mostrarDetalhes([detractors,passives,promoters]) {
            this.dados_grafico_pie = {
                series: [
                    {
                        type:'pie',
                        radius: ['50%', '70%'],
                        color: ['#1F9D55','#F2D024','#D7403C'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                },
                                formatter: (param) => (param.name+'\n'+param.value+'\n('+param.percent+'%)').replace('.',',')
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data:[
                            {value:promoters, name:'Promoters'},
                            {value:passives, name:'Passives'},
                            {value:detractors, name:'Detractors'},
                        ]
                    },
                    {
                        type:'pie',
                        radius: ['0%'],
                        color:['black'],
                        label: {
                            position: 'center',
                            show: true,
                            fontSize:60,
                            fontWeight: 'bolder',
                            formatter: (params) => params.value || '',
                        },
                        data:[
                            {value:this.getTotal},
                        ]
                    }
                ]
            }
        },
        getDetalhes(params) {
            if(!params.selected) {
                this.mostrar_tabela = true
                this.carregar_tabela = true
                let dados_tabela = []
                this.dados_detalhados.map(item =>{
                    return item.map(value =>{
                        dados_tabela.push(value)
                    })
                })
                const filter = params.name
                if(params.seriesIndex == 0 ){
                    dados_tabela = dados_tabela.filter(value => {
                        return  filter=='Detractors'? value.nota <=6 : 
                                filter=='Passives'? value.nota == 7 || value.nota == 8 :
                                filter=='Promoters' ? value.nota == 9 || value.nota == 10 : ''
                    })
                }
                this.dados_tabela = dados_tabela
                const media = (this.dados_tabela.reduce( ( prevVal, elem ) => prevVal + elem.nota, 0 )/this.dados_tabela.length).toFixed(2)
                this.columns[3].title = 'Média '+media
                this.carregarActives()
                if(params.name == 'Detractors'){
                    this.actives_detractors[0].all = 'border-red'
                }else {
                    this.actives_detractors[0].all = ''
                }
                if(params.name == 'Passives'){
                    this.actives_passives[0].all = 'border-yellow'
                }else {
                    this.actives_passives[0].all = ''
                }
                if(params.name == 'Promoters'){
                    this.actives_promoters[0].all = 'border-green'
                }else {
                    this.actives_promoters[0].all = ''
                }
                setTimeout(() => {
                    this.carregar_tabela = false  
                }, 500)
            }else {
                this.mostrar_tabela = false
                this.actives_detractors[0].all = ''
                this.actives_passives[0].all = ''
                this.actives_promoters[0].all = ''
            }
        },
        getDadosDetalhados(params) {
            this.carregarActives()
            this.mostrar_tabela = false
            if(!params.selected) {
                if(params.seriesName != 'NPS'){
                    this.dados_detalhados = this.filter(this.dados).filter((item,key) => {
                        return key == params.dataIndex
                    })
                    this.filter(this.dados).filter((item,key) => {
                        return key == params.dataIndex
                    })
                }else{
                    this.dados_detalhados = this.nps.filter((item,key) => {
                        return key == params.dataIndex
                    }).map(item => {
                        return item.dados
                    })[0]
                }
                this.mostrarDetalhes([
                    this.getScore('detractors').value,
                    this.getScore('passives').value,
                    this.getScore('promoters').value,
                ])
            }else {
                this.dados_detalhados = this.dados
                this.mostrarDetalhes([
                    this.getScore('detractors').value,
                    this.getScore('passives').value,
                    this.getScore('promoters').value,
                ])
            }
        },
        hover(params) {
            if(params.seriesIndex == 0 ){
                this.dados_grafico_pie.series[1].data[0].value = ''
            }
        },
        out(params) {
            this.dados_grafico_pie.series[1].data[0].value = this.getTotal
        },
        getScore(filter,dados=this.dados_detalhados,total=this.getTotal) {
            const value = dados.map(item => {
                return item.filter(value => {
                    if(this.isNumber(filter)) {
                        if(filter==0){
                            return value.nota == filter || value.nota == null
                        }
                        return value.nota == filter
                    }else {
                        return  filter=='detractors'? value.nota <=6 : 
                                filter=='passives'? value.nota == 7 || value.nota == 8 :
                                filter=='promoters' ? value.nota == 9 || value.nota == 10 : ''
                    }
                })
            }).map(item => ({
                value: item.length
            })).reduce( ( prevVal, elem ) => prevVal + elem.value, 0 )
            
            let percent = 0
            percent = parseFloat(((value/total)*100).toFixed(3)).toFixed(2)
            return {value:value,percent:percent}
        },
        getActives(index,type,nota) {
            this.mostrar_grafico_pie = false
            this.$nextTick(() => {
                this.mostrar_grafico_pie = true 
            }) 
            this.carregarActives()
            this.mostrar_tabela = true
            this.carregar_tabela = true
            let dados_tabela = []
            this.dados_detalhados.map(item =>{
                return item.map(value =>{
                    dados_tabela.push(value)
                })
            })
            this.dados_tabela = dados_tabela.filter(value => {
                    if(nota==0){
                        return value.nota == nota || value.nota == null
                    }
                    return value.nota == nota 
            })
            this.columns[3].title = ' '
            this.carregar_tabela = false
            if(type == 'detractors'){ 
                this.actives_detractors[index].value = 'border-red'
            }
            if(type == 'passives'){
                this.actives_passives[index].value = 'border-yellow'
            }
            if(type == 'promoters'){
                this.actives_promoters[index].value = 'border-green'
            }
        },
        carregarActives(){
            this.actives_detractors = [
                {
                        all:''
                },
                {
                    value:''
                },
                {
                    value:''
                },
                {
                    value:''
                },
                {
                    value:''
                },
                {
                    value:''
                },
                {
                    value:''
                },
                {
                    value:''
                },
            ]
            this.actives_passives=[
                {
                    all:''
                },
                {
                    value:''
                },
                {
                    value:''
                },
            ],
            this.actives_promoters=[
                {
                    all:''
                },
                {
                    value:''
                },
                {
                    value:''
                },
            ]
        },
        caregarLegenda(size) {
            let legenda = []
            if (this.format === "semanal") {
                legenda = ["Esta sem.", "1 sem. atrás"]
                for (let i = 2; i < size; i++) {
                    legenda[i] = `${i} sem. atrás`
                }
            } else {
                for (let i = 0; i < size; i++) {
                    legenda[i] = moment().subtract(i, 'months').format("MMMM/YY")
                }
            }
            return legenda.reverse()
        },
        isNumber(val) {
            return typeof val === "number"
        },
        exportData() {
            let dados = this.$refs.table.data
            dados = dados.map(item => {
                const id_pessoa = item.id_pessoa+' - '
                let nome_pessoa = item.nome_pessoa
                nome_pessoa = nome_pessoa?id_pessoa+nome_pessoa:id_pessoa
                item.nome_pessoa = nome_pessoa

                const id_empresa = item.id_empresa+' - '
                let nome_empresa = item.nome_empresa
                nome_empresa = nome_empresa?id_empresa+nome_empresa:id_empresa
                item.nome_empresa = nome_empresa

                return item
            })
            this.$refs.table.exportCsv({
                filename: 'NPS '+this.type,
                data:dados
            });
        }   
    },
    created() {
        this.carregarDados()
        this.carregarActives()
    },
    watch: {
        refresh(){
            if (this.refresh){
                this.formato = 'semanal'
                this.periodo = 6
                this.mostrar_tabela = false
                this.carregarDados()
            }
        },
        download(){
            if(this.download){
               this.exportData() 
            }
        },
        close(){
            if (this.close){
                this.mostrar_tabela = false
                this.mostrar_grafico = false
            } else {
                this.mostrar_grafico = true
            }    
        },
        mostrar_tabela(){
            this.$emit('download',this.mostrar_tabela)
        }
    }
}
</script>